// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_df-0";
export var actionModalContentContainer = "_df-1";
export var createTagButton = "_df-2";
export var footerContainer = "_df-7";
export var fullWidthDivider = "_df-3";
export var hasCreateTagButton = "_df-4";
export var noCreateTagButton = "_df-5";
export var tagsContainer = "_df-6";
export var tagsModalContentContainer = "_df-8";